import {useState, useEffect} from 'react';
import {getDigitalCodesLowInventory} from '@/services/rewardCatalog';
import {logger} from '@/helpers/logger';

/**
 * Custom hook to fetch and manage digital codes low inventory data
 * @returns {Object} Object containing zeroLeftRewards and lowInventoryRewards arrays
 */
const useLowInventory = () => {
  const [zeroLeftRewards, setZeroLeftRewards] = useState([]);
  const [lowInventoryRewards, setLowInventoryRewards] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchLowInventory = async () => {
      try {
        const res = await getDigitalCodesLowInventory();
        if (!mounted) return;
        setZeroLeftRewards(res?.zeroLeftRewards || []);
        setLowInventoryRewards(res?.lowInventoryRewards || []);
      } catch (err) {
        logger.error('Error fetching digital codes low inventory', err);
      }
    };
    fetchLowInventory();
    return () => {
      mounted = false;
    };
  }, []);

  return {zeroLeftRewards, lowInventoryRewards};
};

export default useLowInventory;
